import * as React from 'react';
import Logo from '../../Assets/images/logo-navbar.svg';
import LinearProgress from '@material-ui/core/LinearProgress';
import './Loading.scss';

const Loading = () => (<div className="loading-container">
	<img src={Logo} alt="Logo" className="loading-logo" />
	<div className="loading-content">
		<LinearProgress className="loading-content-progress" />
	</div>
</div>);

export default Loading;
